module.exports = __webpack_public_path__ + "static/img/send.3e10a16.png";


//////////////////
// WEBPACK FOOTER
// ./static/other/send.png
// module id = TXx/
// module chunks = 1